<template lang="pug">
  v-container(fluid grid-list-md)
    router-view
</template>
<script>

export default {
  name: 'adImage',
   data() {
    return {}
  },
}
</script>
